import * as React from 'react'

class ThankYou extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            thankYou:this.props.cmsData,
            particulars: {
                youAddress: {
                    gender: '',
                    firstName: '',
                    lastName: '',
                },
                youContact: {
                    email: '',
                    phone: '',
                },
            },
            leaveANote: {
                subjectName: '',
                subject: '',
                message: ''
            }
        }
    }

    getLocalStorage(key) {    
        var jsonData = localStorage.getItem(key);

        if (!jsonData) { 
        return {}; 
        }

        return JSON.parse(jsonData);
    }

    componentDidMount() {
        let data = this.getLocalStorage('contact-form-submiting');
        if( !jQuery.isEmptyObject(data) ) {
            let {particulars,leaveANote} = data;
            this.setState({
                particulars: particulars,
                leaveANote: leaveANote
            });
        }
        else {
            let currentURL  = window.location.href
            if(!currentURL.includes('elementor-preview')){
                window.location.href = '/'
            }
        }
    }

    render() {
        let {particulars, leaveANote,thankYou} = this.state;
        let {title,message} = thankYou
        return (
            <>
                <div className="row">
                    <div className="col-12 px-lg-6">
                        <div className="ecf-contact-us__offset-box__particular">
                            <h5>{title}</h5>
                            <p>{message}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 px-lg-6">
                        <div className="ecf-contact-us__thank-box"> 
                            <h5>Summary</h5>
                            <h6 className="ecf-contact-us__thank-box__sm-heading">Your particulars</h6>
                            <ul className="ecf-contact-us__thank-box__list">
                                <li>
                                    <div className="ecf-contact-us__thank-box--left">Name</div>
                                    <div className="ecf-contact-us__thank-box--right">
                                        {particulars.youAddress.gender} {particulars.youAddress.firstName} {particulars.youAddress.lastName}
                                    </div>
                                </li>
                                <li>
                                    <div className="ecf-contact-us__thank-box--left">Email address</div>
                                    <div className="ecf-contact-us__thank-box--right">
                                        {particulars.youContact.email}
                                    </div>
                                </li>
                                <li>
                                    <div className="ecf-contact-us__thank-box--left">Mobile number</div>
                                    <div className="ecf-contact-us__thank-box--right">
                                        {particulars.youContact.phone}
                                    </div>
                                </li>
                            </ul>
                            <div className="ecf-contact-us__thank-box__line"></div>
                            <h6 className="ecf-contact-us__thank-box__sm-heading">Leave us a note</h6>
                            <ul className="ecf-contact-us__thank-box__list">
                                <li>
                                    <div className="ecf-contact-us__thank-box--left">Subject</div>
                                    <div className="ecf-contact-us__thank-box--right">
                                        {leaveANote.subjectName}
                                    </div>
                                </li>
                                <li>
                                    <div className="ecf-contact-us__thank-box--left">Message</div>
                                    <div className="ecf-contact-us__thank-box--right">
                                        {leaveANote.message}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ThankYou;